import { render, staticRenderFns } from "./activity-wrapper.vue?vue&type=template&id=026e6548&scoped=true&"
import script from "./activity-wrapper.vue?vue&type=script&lang=js&"
export * from "./activity-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./activity-wrapper.vue?vue&type=style&index=0&id=026e6548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026e6548",
  null
  
)

component.options.__file = "activity-wrapper.vue"
export default component.exports